export default "__VITE_ASSET__804650aa__"